import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { isSameOriginReferrer } from '../api/analytics';

/**
 * 言語コードを検証し、無効な場合はリダイレクトするコンポーネント
 * ja/en以外の言語コードの場合はenにリダイレクト
 */
export const LanguageRedirect = () => {
  const { lang } = useParams<{ lang: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (lang && lang !== 'ja' && lang !== 'en') {
      // 現在のパスから言語コードを除いた部分を取得
      const currentPath = window.location.pathname;
      let pathWithoutLang = currentPath.replace(/^\/[^/]+/, '') || '/';
      // ルートパスの場合は空文字列にして末尾のスラッシュを避ける
      if (pathWithoutLang === '/') {
        pathWithoutLang = '';
      }
      navigate(`/en${pathWithoutLang}${window.location.search}`, { replace: true });
    }
  }, [lang, navigate]);

  return null;
};

/**
 * ルートパス（/）にアクセスした場合の言語リダイレクト
 * ブラウザのAccept-Languageヘッダーに基づいて適切な言語にリダイレクト
 * 外部サイトからのアクセスの場合、元のリファラーを state で渡し遷移先の usePageView で 1 回だけ記録する
 */
export const RootRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const documentReferrer = document.referrer || '';
    const isExternalReferrer = documentReferrer && !isSameOriginReferrer(documentReferrer);

    const browserLang = navigator.language || navigator.languages?.[0] || 'en';
    const langCode = browserLang.toLowerCase().split('-')[0];
    const targetLang = langCode === 'ja' ? 'ja' : 'en';

    const search = window.location.search;
    const hash = window.location.hash;
    const targetPath = `/${targetLang}${search}${hash}`;

    if (isExternalReferrer && documentReferrer) {
      navigate(targetPath, { replace: true, state: { referrer: documentReferrer } });
    } else {
      navigate(targetPath, { replace: true });
    }
  }, [navigate]);

  return null;
};

